<script lang="ts">
  import { userbaseStore, InventoryStore } from "../../stores/stores";
  import Button from "../../shared/Button.svelte";
  import Modal from "../../shared/Modal.svelte";
  import EntryDetails from "./EntryDetails.svelte";
  import AddEntryForm from "./AddEntryForm.svelte";
  import { DatabaseName, ArticleType } from "../../stores/types";
  import type { Entry, DBInventoryEntry, Article } from "../../stores/types";
  import Accordion from "../../shared/Accordion.svelte";
  let visible = false;
  let inventoryPromise = null;
  let inventory = [];

  InventoryStore.subscribe((value) => {
    inventory = value;
  });

  const databaseName = DatabaseName.INVENTORY.toString();
  $: inventoryPromise = $userbaseStore.openDatabase({
    databaseName,
    changeHandler,
  });

  function changeHandler(items: [DBInventoryEntry]) {
    inventory = items;

    //    inventory.sort(sortInventory);

    console.log(inventory);
  }

  var sortInventory = function (a: DBInventoryEntry, b: DBInventoryEntry) {
    var nameA = a.item.article.item.name.toUpperCase();
    var nameB = b.item.article.item.name.toUpperCase();
    if (nameA < nameB) {
      return -1;
    }
    if (nameA > nameB) {
      return 1;
    }
    return 0;
  };

  let showModal = false;
  const toggleModal = () => {
    showModal = !showModal;
  };

  const addIngredient = (e) => {
    showModal = false;
    visible = true;
  };
</script>

<Modal {showModal} on:click={toggleModal}>
  <AddEntryForm on:addIngredient={addIngredient} />
</Modal>
<div>
  <div class="add-ingredient">
    <Button type="secondary" on:click={toggleModal}
      >Neue Zutaten <span
        style="font-size:medium; color:white; margin-left: 10px;"
        ><i class="fas fa-plus-circle" /></span
      ></Button
    >
  </div>
  <div>
    <Accordion title="Sauerteig" {visible}>
      <div class="ingredient-list">
        {#each inventory as dbEntry}
          <EntryDetails {dbEntry} itemId={dbEntry.itemId} />
        {/each}
      </div>
    </Accordion>
    <Accordion title="Mehl" {visible}>
      <div class="ingredient-list">
        {#each inventory as dbEntry}
          <EntryDetails {dbEntry} itemId={dbEntry.itemId} />
        {/each}
      </div>
    </Accordion>
  </div>
</div>

<style>
  .add-ingredient {
    text-align: right;
  }
  .ingredient-list {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
    grid-gap: 20px;
  }
</style>
